import { flow, types } from "mobx-state-tree";

import { AuthStore } from "./AuthStore";
import { MeasurementStore } from "./MeasurementStore";
import { SensorStore } from "./SensorStore";
import { RoomStore } from "./RoomStore";
import { SensorGroupStore } from "./SensorGroupStore";
import { NotificationStore } from "./NotificationStore";

const RootStore = types.model({
  authStore: types.optional(AuthStore, {}),
  measurementStore: types.optional(MeasurementStore, { measurements: {} }),
  sensorStore: types.optional(SensorStore, { sensors: {} }),
  roomStore: types.optional(RoomStore, { rooms: {} }),
  sensorGroupStore: types.optional(SensorGroupStore, { sensor_groups: {} }),
  notificationStore: types.optional(NotificationStore, { notifications: [] })
}).actions(self => ({
  
  bootstrap: flow(function* bootstrap() {
    yield self.roomStore.bootstrap();
  }),

})).views(self => ({
  notifications() {
    return self.notificationStore;
  }
}));

export default RootStore;
